import { z } from "zod";

// Runtime contract for a user's role. Mirrors the BFFE `Role` enum, which serde
// serializes PascalCase (Admin | Client). Validate server/stored roles against
// this instead of blind-casting an arbitrary string to `AuthRole`.
export const AuthRoleSchema = z.enum(["Admin", "Client"]);

export type { Role as AuthRole } from "./generated/Role";
export type { AuthUserResponse as AuthUser } from "./generated/AuthUserResponse";
export type { LoginRequest } from "./generated/LoginRequest";
export type { ClientLoginRequest } from "./generated/ClientLoginRequest";
export type { LogoutRequest } from "./generated/LogoutRequest";
export type { RefreshRequest } from "./generated/RefreshRequest";
export type { LoginResponse } from "./generated/LoginResponse";
export type { CsrfResponse } from "./generated/CsrfResponse";
export type { SessionResponse } from "./generated/SessionResponse";
export type { ChangePasswordRequest } from "./generated/ChangePasswordRequest";
export type { CompleteRegistrationRequest } from "./generated/CompleteRegistrationRequest";
export type { ForgotPasswordRequest } from "./generated/ForgotPasswordRequest";
export type { ForgotPasswordResponse } from "./generated/ForgotPasswordResponse";
export type { ResetPasswordRequest } from "./generated/ResetPasswordRequest";
